const miscellaneousToOption = ({ id, name }) => ({
  value: id,
  label: name,
})

export { miscellaneousToOption }
